module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inbox-sidebar"
  }, [_c('router-link', {
    staticClass: "btn green compose-btn btn-block",
    attrs: {
      "to": "/inbox/new-message"
    }
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Nova")])])]), _vm._v(" "), _c('ul', {
    staticClass: "inbox-nav"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/inbox"
    }
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Recebidas")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/inbox/send-message"
    }
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Enviadas")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c96989aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/inbox/sidebar-menu/sidebar-menu.vue
// module id = 1108
// module chunks = 1